// Save a Blob as a file. The link is attached for the click (some browsers ignore a click on a
// detached link) and its URL is released only after the click has been handled: revoking it in the
// same tick can cancel the download before it starts.
export const downloadBlob = (blob, fileName) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 0);
};
